import React from 'react';
import { withStyles } from 'material-ui/styles';
import { FormControl } from 'material-ui/Form';
import Select from 'react-select';
import _find from 'lodash/find';

class VideoSettings extends React.Component {

    render() {

        const {
            classes,
            videoSettings,
            selectedVideoSettings,
            selectVideoSetting,
        } = this.props;

        let Selects = videoSettings.map((setting, index) => {
            let selectedOptionsForThisSetting;
            let multiple = setting.multiple === 1 ? true : false;
            let selectedSection = _find(
                selectedVideoSettings, { id: setting.id }
            );

            if (multiple) {
                selectedOptionsForThisSetting = [];
                if (selectedSection !== undefined) {
                    selectedOptionsForThisSetting = selectedSection.options;
                }
            } else {
                selectedOptionsForThisSetting = null;
                if (selectedSection !== undefined) {
                    selectedOptionsForThisSetting = selectedSection.options[0];
                }
            }

            return (
                <FormControl key={index} className={classes.formControl}>
                    {setting.name}
                    <Select
                        multi={multiple}
                        placeholder={setting.name}
                        name={`select-multiple-chip-${index}`}
                        id={`select-multiple-chip-${index}`}
                        value={selectedOptionsForThisSetting}
                        valueKey={'id'}
                        labelKey={'option'}
                        onChange={selectedOptions => selectVideoSetting(selectedOptions, setting)}
                        options={setting.options}
                        fullWidth
                    />
                </FormControl>
            )
        });

        return (
            <div className={classes.root}>
                {Selects}
            </div>
        );
    }
}

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        marginBottom: 50,
    },
    formControl: {
        margin: 5,
        minWidth: 100,
        width: '100%'
    },
});

export default withStyles(styles)(VideoSettings);


// WEBPACK FOOTER //
// ./src/containers/builder/form/video_settings.js